<template>
    <LayoutBlock
        :tutorial_dialog="tutorial_dialog"
        v-on:closeDialog="handleCloseDialog"
        >
        <div class="d-flex flex-column" v-if="measures">
            <div class="pl-2 pb-2 subtitle-1" v-if="conf.title" >{{conf.title}}</div>
            <v-container class="ma-0 pa-0">
                <v-row no-gutters>
                    <v-col cols="6">
                    <!-- componente a parte ha flag obbligatorio -->
                        <v-radio-group class="pa-0 ma-0" disabled v-model="measures.zero_device" label="Mantenimento dello zero">
                            <v-radio label="Attivo" value="on"></v-radio>
                            <v-radio label="Disattivo" value="off"></v-radio>
                            <v-radio label="Fuori zona intervento" value="out"></v-radio>
                        </v-radio-group>
                    </v-col>
                    <v-col cols="6">
                        <v-radio-group class="no_space_vertical" :disabled="preview" v-model="measures.hi_res" label="Alta risoluzione">
                        <v-radio label="Attivo" value="on"></v-radio>
                        <v-radio label="Disattivo" value="off"></v-radio>
                        </v-radio-group>
                    </v-col>
                </v-row>
                <v-row no-gutters v-if="!preview">
                    <div class="d-flex flex-shrink-1 flex-grow-0 py-2" v-if="!onlyPrimaries">
                        <v-btn @click="openWeightDialog">Scegli zavorra</v-btn>
                    </div>
                    <div class="d-flex flex-shrink-0 flex-grow-1 justify-end py-2">
                        <v-btn color="primary" @click="handlePlaceholders()">Riempimento automatico</v-btn>
                    </div>
                </v-row>
                <v-row no-gutters>
                    <span class="subtitle-2"><b>Misure Asc.</b></span>
                </v-row>
                <v-row no-gutters>
                <v-simple-table class="measure_table">
                <template v-slot:default>
                    <thead class="expansion">
                    <tr>
                        <th class="table-text-blocks text-right">{{data.block.conf.headers.divs}}</th>
                        <th class="table-text-blocks text-right">{{data.block.conf.headers.mass}}  <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                        <th class="table-text-blocks text-right">{{data.block.conf.headers.reading}}  <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                        <th class="table-text-blocks text-right" v-if="measures.hi_res == 'off'">{{data.block.conf.headers.addLoad}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                        <th class="table-text-blocks text-right" v-if="measures.hi_res == 'off'">{{data.block.conf.headers.p}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                        <th class="table-text-blocks text-right">{{data.block.conf.headers.error}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                        <th class="table-text-blocks text-right">{{data.block.conf.headers.error_corr}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                        <th class="table-text-blocks text-right">{{data.block.conf.headers.mpe}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                        <th class="table-text-blocks text-right">{{data.block.conf.headers.result}}</th>
                    </tr>
                    </thead>
                    <tr v-for="(item,index) of measures.items_up" :key="item.index">
                            <td class="table-blocks d-flex align-center">
                                <v-icon class="d-flex flex-shrink-1 flex-grow-0" v-if="index >= conf.min_readings && !preview" @click="removeRow(index)">delete</v-icon>
                                <div v-else class="d-flex mr-6"></div>
                                <div class="d-flex justify-center flex-shrink-0 flex-grow-1">{{index + 1}}</div>
                            </td>
                            <td class="table-blocks with_scroll">
                                <NumericField dense outlined
                                v-model="item.mass"
                                solo hide-details
                                :readonly="preview"
                                @input="changeMass(item)"
                                :precision="currentPrecision"
                                :class="readingWarning(item.mass)"
                                />
                            </td>
                            <td class="table-blocks with_scroll">
                                <NumericField dense outlined
                                v-model="item.reading"
                                solo hide-details
                                :readonly="preview"
                                @input="changeLinearityReading(item, 'up')"
                                :class="readingWarning(item.reading)"
                                :placeholder="readingPlaceholder(item.mass)"
                                :precision="currentPrecision"
                                :enableicons="!preview"
                                :addfunc="readingAddFunc"
                                :subfunc="readingSubFunc"
                                :row="item"
                                :fieldname="'reading'"
                                :range="calcMinRange(item.reading)"
                                />
                            </td>

                            <td class="table-blocks with_scroll" v-if="measures.hi_res != 'on'">
                                <NumericField dense outlined
                                v-model="item.addLoad"
                                solo hide-details
                                :readonly="preview"
                                @input="changeLinearityAddLoad(item, 'up')"
                                :placeholder="calculateAddLoadPlaceholder(item.reading)"
                                :class="addLoadWarning(item.addLoad, item.reading)"
                                :precision="high_precision"
                                :enableicons="!preview"
                                :addfunc="loadAddFunc"
                                :subfunc="loadSubFunc"
                                :row="item"
                                :fieldname="'addLoad'"
                                :range="calcMinRange(item.reading)"
                                />
                            </td>

                            <td class="table-text-blocks text-right" v-if="measures.hi_res != 'on'">
                                <b>{{item.p | formatNumber}}</b>
                            </td>

                            <td class="table-text-blocks text-right">
                                <b>{{item.error | formatNumber}}</b>
                            </td>

                            <td class="table-text-blocks text-right">
                                <b>{{item.error_corr | formatNumber}}</b>
                            </td>

                            <td class="table-text-blocks text-right">
                                <b>{{item.mpe | formatNumber}}</b>
                            </td>
                            <td class="table-text-blocks text-center">
                                <StatusIcon :status="item.result" />
                            </td>
                        </tr>
                    </template>
                    </v-simple-table>
            </v-row>
            <v-row no-gutters>
                <div class="d-flex flex-column flex-grow-1 flex-shrink-0 table-bordered ma-2">
                    <div v-if="precision_overflow_up" class="d-flex error--text caption"><StatusIcon status="failed" small /><b>Controlla valori e precisione letture</b></div>
                    <div v-if="addLoad_overflow_up" class="d-flex error--text caption"><StatusIcon status="failed" small /><b>Controlla carico addizionale</b></div>
                </div>
            </v-row>
            <div class="d-flex flex-column" v-if="onlyPrimaries">
            <v-row no-gutters>
                <span class="subtitle-2"><b>Misure Disc.</b></span>
            </v-row>
            <v-row no-gutters>
                <v-simple-table class="measure_table">
                <template v-slot:default>
                    <thead class="expansion">
                    <tr>
                        <th class="table-text-blocks text-right">{{data.block.conf.headers.divs}}</th>
                        <th class="table-text-blocks text-right">{{data.block.conf.headers.mass}}  <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                        <th class="table-text-blocks text-right">{{data.block.conf.headers.reading}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                        <th class="table-text-blocks text-right" v-if="measures.hi_res == 'off'">{{data.block.conf.headers.addLoad}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                        <th class="table-text-blocks text-right" v-if="measures.hi_res == 'off'">{{data.block.conf.headers.p}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                        <th class="table-text-blocks text-right">{{data.block.conf.headers.error}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                        <th class="table-text-blocks text-right">{{data.block.conf.headers.error_corr}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                        <th class="table-text-blocks text-right">{{data.block.conf.headers.mpe}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                        <th class="table-text-blocks text-right">{{data.block.conf.headers.result}}</th>

                    </tr>
                    </thead>
                    <tr v-for="(item,index) of measures.items_down" :key="item.index">
                        <td class="table-blocks d-flex align-center">
                            <div class="d-flex justify-center flex-shrink-0 flex-grow-1">{{index + 1}}</div>
                        </td>
                        <td class="table-blocks with_scroll">
                            <NumericField dense outlined
                            v-model="item.mass"
                            hide-details disabled
                            :precision="currentPrecision"
                            />
                        </td>

                        <td class="table-blocks with_scroll">
                            <NumericField dense outlined
                            v-model="item.reading"
                            solo hide-details
                            :readonly="preview"
                            :disabled="index == 0"
                            @input="changeReading(item, currMaxRange)"
                            :class="readingWarning(item.reading, currMaxRange)"
                            :placeholder="readingPlaceholder(item.mass)"
                            :precision="currentPrecision"
                            :enableicons="!preview"
                            :addfunc="readingAddFunc"
                            :subfunc="readingSubFunc"
                            :row="item"
                            :fieldname="'reading'"
                            :range="currMaxRange"
                            />
                        </td>

                        <td class="table-blocks with_scroll" v-if="measures.hi_res != 'on'">
                            <NumericField dense outlined
                            @input="changeAddLoad(item, currMaxRange)"
                            v-model="item.addLoad"
                            solo hide-details
                            :readonly="preview"
                            :disabled="index == 0"
                            :precision="high_precision"
                            :placeholder="calculateAddLoadPlaceholder(item.reading, currMaxRange)"
                            :class="addLoadWarning(item.addLoad, item.reading, currMaxRange)"
                            :enableicons="!preview"
                            :addfunc="loadAddFunc"
                            :subfunc="loadSubFunc"
                            :row="item"
                            :fieldname="'addLoad'"
                            :range="currMaxRange"
                            />
                        </td>
                        <td class="text-right table-text-blocks" v-if="measures.hi_res != 'on'">
                            <b>{{item.p | formatNumber}}</b>
                        </td>

                        <td class="text-right table-text-blocks">
                            <b>{{item.error | formatNumber}}</b>
                        </td>

                        <td class="text-right table-text-blocks">
                            <b>{{item.error_corr | formatNumber}}</b>
                        </td>
                        <td class="text-right table-text-blocks">
                            <b>{{item.mpe | formatNumber}}</b>
                        </td>
                        <td class="table-text-blocks text-center">
                            <StatusIcon 
                                :status="item.result"
                                :tooltip_text="row_tooltip[item.result]" />
                        </td>
                    </tr>
                </template>
                </v-simple-table>
            </v-row>
            </div>
            <v-row no-gutters v-if="onlyPrimaries">
                <div class="d-flex flex-column flex-grow-1 flex-shrink-0 table-bordered ma-2">
                    <div v-if="precision_overflow_down" class="d-flex error--text caption"><StatusIcon status="failed" small /><b>Controlla valori e precisione letture</b></div>
                    <div v-if="addLoad_overflow_down" class="d-flex error--text caption"><StatusIcon status="failed" small /><b>Controlla carico addizionale</b></div>
                </div>        
            </v-row>
            <v-row no-gutters>
                <div class="d-flex flex-shrink-0 flex-grow-1 justify-end py-2">
                    <v-btn v-if="checkStatic && !preview" color="primary" @click="addRow"><v-icon class="pa-2">add_box</v-icon>aggiungi misura</v-btn>
                </div>
            </v-row>
            </v-container>
        </div>
        <WeightDialog
        ref="weightDialogRef"
        :data="weightDialogData"
        @changedWeight="changeRows"
        />
    </LayoutBlock>
</template>
<script>
import {linearity_item_new} from "../../../utils/itemBlockSchema"
import {BaseIsoSimple} from "../../../utils/baseIsoSimple"
import WeightDialog from "../../../components/dialogs/WeightDialog"
import LayoutBlock from "../../../components/utils/LayoutBlock"
import StatusIcon from "../../../components/utils/StatusIcon"
// import _ from 'lodash'
import Big from "big.js"

export default {
    components: {LayoutBlock, StatusIcon, WeightDialog},
    mixins:[BaseIsoSimple],
    data(){
        return{
            pagination: {'rowsPerPage': -1},
            items: [],
            tutorial_dialog: {
                dialog: false,
                message: "Tutorial per la linearità nawi"
            },
            currMaxRange: null,
            weightDialogData: {
                dialog: false,
                totalMass: 0,
                maxRange: 0,
                commonData: null
            }
        }
    },

    computed: {
        
        precision_overflow(){
            if(this.measures){
                return this.precision_overflow_up && this.precision_overflow_down
            } else {
                return false
            }
        },
        precision_overflow_up() {
            if(this.measures){
                for (let elm of this.measures.items_up) {
                    let res = this.checkReading(elm.reading)
                    switch (res) {
                        case 'uncomplete':
                        case 'done':
                            break
                        case 'failed':
                            return true
                    }
                }
            }
            return false
        },
        precision_overflow_down() {
            if(this.measures){
                let range = this.instrument_data.custom_data.multiext ? this.currMaxRange : null
                
                for (let elm of this.measures.items_down) {
                    let res = this.checkReading(elm.reading, range)
                    switch (res) {
                        case 'uncomplete':
                        case 'done':
                            break
                        case 'failed':
                            return true
                    }
                }
            }
            return false
        },
        addLoad_overflow_up() {
            if (this.measures.hi_res == 'off') {
                for (let elm of this.measures.items_up) {
                    if (!this.checkLoad(elm.addLoad, elm.reading)) {
                        return true
                    }
                } return false
            } else {
                return false
            }
        },
        addLoad_overflow_down() {
            if (this.measures.hi_res == 'off') {
                let range = this.instrument_data.custom_data.multiext ? this.currMaxRange : null
                for (let elm of this.measures.items_down) {
                    if (!this.checkLoad(elm.addLoad, elm.reading, range)) {
                        return true
                    }
                } return false
            } else {
                return false
            }
        },
    },
    methods: {
        openWeightDialog(){
            this.weightDialogData.totalMass = this.calculateTotal
            this.weightDialogData.maxRange = this.findMaxRange().max
            this.weightDialogData.commonData = this.getCommonData()
            this.weightDialogData.uom = this.instrument_data.uom
            this.$refs.weightDialogRef.setOldWeight(this.measures.weightTotal)
            this.$refs.weightDialogRef.dialog = true
        },
        addRow(){
            let item = linearity_item_new({
                index: this.measures.startingIndex
            })
            let item_down = linearity_item_new({
                index: this.measures.startingIndex
            })
            this.measures.items_down.unshift(item_down)
            this.measures.items_up.push(item)
            this.measures.startingIndex++
        },

        async buildMeasures(){
            this.measures = {
                items_up: [],
                items_down: [],
                zero_device: this.conf.zero_device,
                hi_res: this.conf.hi_res,
                weightTotal: 0,
                startingIndex: 0,
                result: 'uncomplete'
            }
            this.measures.startingIndex = this.data.block.conf.min_readings
            let catVals = await this.buildWithCategory()
            if(catVals){
                for (let i = 0; i< catVals.length; i++ ){
                    let currCatVal = catVals[i]
                    let currMpe = this.calculate_MPE(this.calcMinRange(currCatVal), currCatVal)
                    let item = linearity_item_new({
                        index: i,
                        mass: currCatVal,
                        mpe: currMpe
                    })
                    let item_down = linearity_item_new({
                        index: i,
                        mass: currCatVal,
                        mpe: currMpe
                    })
                    this.measures.items_up.push(item)
                    this.measures.items_down.unshift(item_down)
                }
                this.calculateMaxRange()
            } else {
                for (let i = 0; i< this.data.block.conf.min_readings; i++ ){
                    let item = linearity_item_new({
                        index: i,
                        mass: "0",
                        mpe: "0"
                    })
                    let item_down = linearity_item_new({
                        index: i,
                        mass: "0",
                        mpe: "0"
                    })
                    this.measures.items_up.push(item)
                    this.measures.items_down.unshift(item_down)
                }
            }
        },
        findRow(items, index){
            return items.find(function(a){
                return a.index == index
            })
        },

        calculateMaxRange(){
            if (this.instrument_data.custom_data.multiext){
                let maxItem = this.measures.items_up.reduce((acc, val) => {
                    acc = ( acc === undefined || Big(val.mass).gt(acc.mass)) ? val : acc
                    return acc;
                }, {mass: 0})
                this.currMaxRange = this.calcMinRange(maxItem.mass)
            } else {
                this.currMaxRange = null
            }
        },
        changeMass(row){
            if(row.mass){
                let temp = this.calcMinRange(row.mass)
                row.mpe = this.calculate_MPE(temp, row.mass)
                if(this.onlyPrimaries){
                    let row_down = this.findRow(this.measures.items_down, row.index)
                    row_down.mass = row.mass
                    this.calculateMaxRange()                    
                    if(this.instrument_data.custom_data.multiext){
                        row_down.mpe = this.calculate_MPE(this.currMaxRange, row.mass)
                    } else {
                        this.currMaxRange = temp
                        row_down.mpe = row.mpe
                    }
                }
            }
        },
        calcError(row, range = null){
            if(row){
                if(this.measures.hi_res == 'on'){
                    row.error = this.differenceInt(row.reading, row.mass)
                    this.calculateResult(row)
                } else {
                    if (row.addLoad != null && row.addLoad != ""){
                        row.error = this.differenceInt(row.p, row.mass)
                        if(this.checkLoad(row.addLoad, row.mass, range)){
                            this.calculateResult(row, range)
                        } else {
                            row.result = "failed"
                        }
                    } else {
                        row.result = "uncomplete"
                    }
                }
            }

        },
        calcDiff(){
            let start_error = null
            for(let i=0; i<this.measures.items_up.length;i++){
                let row = this.measures.items_up[i]
                if(row){
                    this.calcError(row)
                    if(i == 0){
                        start_error = row.error
                    } else {
                        row.error_corr = this.differenceInt(row.error, start_error)
                    }
                }
            }
            for(let i=0; i<this.measures.items_down.length;i++){
                let row = this.findRow(this.measures.items_down, i)
                if(row){
                    this.calcError(row, this.currMaxRange)
                    if(i == 0){
                        start_error = row.error
                    } else {
                        row.error_corr = this.differenceInt(row.error, start_error)
                    }
                }
            }
        },
        saveFirst(){

        },
        
        handlePlaceholders(){
            this.convertPlaceholders(this.measures.items_up)
            if(this.instrument_data.custom_data.multiext){
                this.calculateMaxRange()
                console.log("$$ maxrange", this.currMaxRange, this.instrument_data.custom_data.multiext)
                this.convertPlaceholders(this.measures.items_down, "", this.currMaxRange)
            } else {
                this.convertPlaceholders(this.measures.items_down)
            }
        },
        removeRow(index){
            // console.log("$$ remove row", index, this.measures.items_down.length - index - 1, this.measures.items_down)
            let item = this.measures.items_up.splice(index,1)
            this.measures.items_down.splice(this.measures.items_down.length - index - 1,1)
            console.log(item)
        },
        calcBlockResult() {
            // console.log('CALC BLOCK RESULT')
            let result_up = 'done'
            result_up = this.measures.items_up.reduce(function(result, item){
                let res = 'done'
                switch (item.result) {
                    case 'uncomplete':
                        res = 'uncomplete'
                        break
                    case 'failed':
                        if (result == 'uncomplete') {
                            res = 'uncomplete'
                        } else {
                            res = 'failed'
                        }
                        break
                    case 'done':
                        res = result
                        break
                }
                return res
            }, 'done')
            let result_down = 'done'
            result_down = this.measures.items_down.reduce(function(result, item){
                let res = 'done'
                switch (item.result) {
                    case 'uncomplete':
                        res = 'uncomplete'
                        break
                    case 'failed':
                        if (result == 'uncomplete') {
                            res = 'uncomplete'
                        } else {
                            res = 'failed'
                        }
                        break
                    case 'done':
                        res = result
                        break
                }
                return res
            }, 'done')
            // console.log('CALC BLOCK RESULT', result_up, result_down)
            if (result_up == result_down && result_up == "done") {
                if(this.precision_overflow_up || this.precision_overflow_down){
                    this.measures.result = 'failed' 
                } else if(this.measures.hi_res == 'off' && (this.addLoad_overflow_up || this.addLoad_overflow_down) ){
                    this.measures.result = 'failed'
                } else {
                    this.measures.result = result_up
                }
            }  else if (result_up == 'uncomplete' || result_down == 'uncomplete') {
                this.measures.result = 'uncomplete'
            } else if (result_up == 'failed' || result_down == 'failed') {
                this.measures.result = 'failed'
            }
            // console.log('CALC BLOCK RESULT', result_up, result_down, this.measures.result)
        },

    }

}
</script>
